import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { StorageLocationsService } from '../storage-locations.service';
import { notDefaultValidator } from 'src/app/validators/not-default';
import { UploadStorageLocations } from '../storage-locations.interface';

@Component({
    selector: 'app-edit-storage-locations',
    templateUrl: './edit-storage-locations.component.html',
    styleUrls: ['./edit-storage-locations.component.scss'],
})
export class EditStorageLocationsComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    serverOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Same server',
            id: 1,
        },
        {
            name: 'Remote server',
            id: 1,
        }
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        location_path: new FormControl(this.data.location_path, [Validators.required]),
        location_server: new FormControl(this.data.location_server, [Validators.required, notDefaultValidator('-1')]),
        ip: new FormControl(this.data.ip, []),
        port: new FormControl(this.data.port, []),
        observatii: new FormControl(this.data.observatii, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditStorageLocationsComponent>,
        private requestService: StorageLocationsService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const payload: UploadStorageLocations = {
            id: this.data.id,
            name: this.form.get('name')?.value,
            slug: this.form.get('slug')?.value,
            location_path: this.form.get('location_path')?.value,
            location_server: this.form.get('location_server')?.value,
            ip: this.form.get('ip')?.value,
            port: this.form.get('port')?.value,
            observatii: this.form.get('observatii')?.value,
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
